// extracted by mini-css-extract-plugin
export default {"photo":"MyProfilePage_photo__yS-cR","placeholder":"MyProfilePage_placeholder__3hLJ+"};